import React, { FC, useEffect, useState } from 'react';
import { CustomerPOTable, WeekCalendar } from '../../../../_designereyes/partials/widgets'
import { PageTitle } from '../../../../_designereyes/layout/core'
import { WeekProvider } from '../../../../_designereyes/partials/widgets/_new/cards/vendors/purchase-order-offer/WeekContext';

const CustomerPOPage = () => {
  return (
    <WeekProvider>
      <div className="mb-4">
        <WeekCalendar viewMode="POManager" table="orders"/>
      </div>
      <div>
        <CustomerPOTable />
      </div>
    </WeekProvider>
  )
}


export const CustomerPOWrapper: FC = () => {
    return (
      <>
        <PageTitle>Customer Purchase Orders</PageTitle>
        <CustomerPOPage />
      </>
    )
};
